import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import {
  EOfferFormatKey,
  IStoreSettingsFormValues
} from '../../../StoreSettings.types';
import { getAbbreviationDropdownTestId } from '../AbbreviationsSettingsV2.consts';
import {
  IAbbreviationDropdownField,
  QuantityFieldPath,
  QuantityFieldValue
} from '../AbbreviationsSettingsV2.types';
import {
  getAbbreviationDropdownOptions,
  getAbbreviationDropdownSelectedValue,
  getQuantityFieldPath,
  parseAbbreviationDropdownValue
} from '../AbbreviationsSettingsV2.utils';

interface IQuantityFormatDropdownFieldProps {
  sectionKey: EOfferFormatKey;
  field: IAbbreviationDropdownField;
  onSelect: (path: QuantityFieldPath, value: QuantityFieldValue) => void;
}

export const QuantityFormatDropdownField = ({
  sectionKey,
  field,
  onSelect
}: IQuantityFormatDropdownFieldProps): React.ReactElement => {
  const { control } = useFormContext<IStoreSettingsFormValues>();
  const fieldPath = getQuantityFieldPath(sectionKey, field.key);
  const rawValue = useWatch({ control, name: fieldPath });

  const options = getAbbreviationDropdownOptions(field);
  const selectedValue = getAbbreviationDropdownSelectedValue(field, rawValue);
  const defaultSelected = options.find(
    (option) => option.value === selectedValue
  );

  const handleOptionChange = (value: string): void => {
    onSelect(fieldPath, parseAbbreviationDropdownValue(field, value));
  };

  return (
    <InputSelectDropdown
      label={field.label}
      options={options}
      defaultSelected={defaultSelected}
      onOptionChange={handleOptionChange}
      shouldCapitalizeOptions={false}
      dataTestId={getAbbreviationDropdownTestId(field.key)}
    />
  );
};
